/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {MimeType} from "../constant/mime-type";
import {FileExtension} from "../constant/file-extension";
import {PartRight} from "../constant/part-right";

@Injectable({
    providedIn: 'root'
})
export class FileExtensionService {

    constructor() {
    }

    getExtension(format) {
        switch (format) {
            //Case we got "image/extension"
            case MimeType.jpg :
                return FileExtension.jpg;
            case MimeType.jpeg :
                return FileExtension.jpeg;
            case MimeType.pjpeg :
                return FileExtension.pjpeg;
            case MimeType.png :
                return FileExtension.png;
            case MimeType.gif :
                return FileExtension.gif;
            case MimeType.tiff :
                return FileExtension.tiff;
            case MimeType.pdf :
                return FileExtension.pdf;
            //Case we already got extension
            case FileExtension.jpg :
                return FileExtension.jpg;
            case FileExtension.jpeg :
                return FileExtension.jpeg;
            case FileExtension.pjpeg :
                return FileExtension.pjpeg;
            case FileExtension.png :
                return FileExtension.png;
            case FileExtension.gif :
                return FileExtension.gif;
            case FileExtension.pdf :
                return FileExtension.pdf;
            default :
                return null;
        }
    };

    getInputAcceptedExtension(formatList) {
        var result = '';

        for (var i = 0; i < formatList.length; i++) {
            result += ',.' + this.getExtension(formatList[i]);
        }
        return result;
    };

    analyser(format) {
        console.debug('Analyse mimeType of ' + format);

        switch (format) {
            case MimeType.jpeg :
                return PartRight.toDownload;
            case MimeType.pjpeg :
                return PartRight.toDownload;
            case MimeType.png :
                return PartRight.toDownload;
            case MimeType.gif :
                return PartRight.toDownload;
            case MimeType.pdf :
                return PartRight.toDownload;
            default:
                return null;
        }
    };
}